import UIComponent from "../ui/component.js";

export class TechSupport extends UIComponent {

    init() {
        this.includeComponents({
            'sendTechSupportMail': 'document@#sendTechSupportMail',
        });

        this.requireComponents({
            'techSupportNotification': 'document@#techSupportNotification',
        })

        this.sendTechSupportMail.enable();
        // Модалку «Письмо отправлено» показываем только после реального ответа сервера,
        // иначе форма прячется даже когда обращение не ушло.
        this.sendTechSupportMail.on('techsupport:sent', this.onSent.bind(this));
    }

    onSent() {
        this.hide();
        this.techSupportNotification.show();
    }
}
